import axios from 'axios';
import Vue from 'vue';

const instance = axios.create({
  baseURL: Vue.env.VUE_APP_APIPATH_FileManager
});

function UploadAsync(data) {
  const headers = { Appkey: Vue.env.VUE_APP_Appkey, AppSecret: Vue.env.VUE_APP_AppSecret };
  return instance.post('/api/v1/files', data, { headers });
}

export default {
  UploadAsync
};
